// extracted by mini-css-extract-plugin
export var top_posts_title = "string-module--top_posts_title--1c535";
export var top_tag_title = "string-module--top_tag_title--fe3e9";
export var top_title = "string-module--top_title--9a362";